module.exports = __webpack_public_path__ + "img/hero-v3-home-xray.9a1500d6.png";